// @ts-nocheck
import React, { useEffect } from "react";
import Header from "./components/Header/Header.js";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import HomeScreen from "./screens/HomeScreen.js";
import Footer from "components/Footer/Footer.js";
import DetailScreen from "./screens/DetailScreen.js";
import ImpactScreen from "./screens/ImpactScreen.js";
import AboutScreen from "./screens/AboutScreen.js";
import ManifestoScreen from "./screens/ManifestoScreen.js";
import FAQScreen from "./screens/FAQScreen.js";
import ContactScreen from "./screens/ContactScreen.js";
import LegalScreen from "./screens/LegalScreen.js";
import AudienceScreen from "./screens/AudienceScreen.js";
import BookScreen from "./screens/BookScreen.js";
import ProjectsScreen from "./screens/ProjectsScreen.js";
import GuideScreen from "./screens/GuideScreen.js";
import SellerListScreen from "./screens/SellerListScreen.js";
import InsightsScreen from "./screens/InsightsScreen.js";
import PostScreen from "./screens/PostScreen.js";
import MapScreen from "./screens/MapScreen.js";
import Loader from "./components/Page/Loader.js";
import NotFoundScreen from "./screens/NotFoundScreen.js";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  return (
    <BrowserRouter>
      <Loader />
      <ScrollToTop />
      <Header />
      <main>
        <Routes>
          <Route path="/" element={<HomeScreen />} />
          <Route path="/book" element={<BookScreen />} />
          <Route path="/projects" element={<ProjectsScreen />} />
          <Route path="/buyers/guide" element={<GuideScreen />} />
          <Route path="/sellers/list" element={<SellerListScreen />} />
          <Route path="/insights" element={<InsightsScreen />} />
          <Route path="/insights/:slug" element={<PostScreen />} />
          <Route path="/map" element={<MapScreen />} />
          <Route path="/buyers" element={<AudienceScreen kind="buyers" />} />
          <Route path="/sellers" element={<AudienceScreen kind="sellers" />} />
          <Route path="/investors" element={<AudienceScreen kind="investors" />} />
          <Route path="/impact" element={<ImpactScreen />} />
          <Route path="/projects/:slug" element={<DetailScreen list="projects" />} />
          <Route path="/services/:slug" element={<DetailScreen list="services" />} />
          <Route path="/about" element={<AboutScreen />} />
          <Route path="/manifesto" element={<ManifestoScreen />} />
          <Route path="/faq" element={<FAQScreen />} />
          <Route path="/contact" element={<ContactScreen />} />
          <Route path="/privacy" element={<LegalScreen kind="privacy" />} />
          <Route path="/terms" element={<LegalScreen kind="terms" />} />
          <Route path="/legal" element={<LegalScreen kind="legal" />} />
          <Route path="/cookies" element={<LegalScreen kind="cookies" />} />
          <Route path="*" element={<NotFoundScreen />} />
        </Routes>
      </main>
      <Footer />
    </BrowserRouter>
  );
}

export default App;
